import { Row, Col } from "react-bootstrap"
import React from "react"
import { LocalizedGuides } from "../../../types/guides"
import GuidesList from "@components/Guides/GuidesList"

export function GuidesListPage({ guides }: { guides: LocalizedGuides[] }) {
  return (
    <Row className={"marginZero paddingZero"}>
      <Col>
        <h1 className="pageTitle">Guide alle scommesse</h1>
        <Row xl={3} lg={2} md={2} sm={12} xs={12}>
          <GuidesList guides={guides} />
        </Row>
      </Col>
    </Row>
  )
}
